module.exports = __webpack_public_path__ + "static/media/voiture_03_full.bd4d76c6.gif";